<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0">
        <crud-facecade
            ref="supplies-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :tableHeight="tableHeight"
            :rowChangesMonitor="true"
            :updateButton="{ enabled: false }"
            new_row_tag="bingo_new"
            @removeItem="removeItem"
        >
            <el-col slot="filter" :span="3" class="align-left" v-if="supplyUseMethod == `1` && useTypeArry.length > 0" v-for="item in useTypeArry" :key="item.label">
                <el-radio v-model="useType" :label="item.label">{{ item.name }}</el-radio>
            </el-col>
            <el-col slot="filter" :span="4" class="align-left" v-if="supplyUseMethod == `0` || (supplyUseMethod == `1` && useTypeArry.length > 0)">
                <item-input
                    ref="scan-code"
                    type="scan"
                    v-model="scancode"
                    :placeholder="supplyUseMethod == `1` ? '请扫码/输入条形码' : '请扫码/输入耗材编号'"
                    :autofocus="true"
                    @input="scanConsumable"
                ></item-input>
            </el-col>
            <template slot="filter-after">
                <el-button size="mini" @click="loadSaveAsView">另存为模板</el-button>
                <el-button type="primary" size="mini" @click="loadTemplatesView" v-if="supplyUseMethod != `1`">提取模板</el-button>
            </template>
        </crud-facecade>
        <cus-dialog class="table-h360" title="提取模板" :visible.sync="collectSupplies.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="addTemplateToList">
            <el-row class="padding20">
                <el-col :span="2" class="align-left"><span class="line-height35">请选模板:</span></el-col>
                <el-col :span="22">
                    <item-input type="groupselect" :collapseTags="false" v-model="collectSupplies.selected_template" :options="collectSupplies.supplies_template" :clearable="true"></item-input>
                </el-col>
            </el-row>
            <list-view :columns="collectSupplies.columnList" :datalist="collectSupplies.datalist"></list-view>
        </cus-dialog>
        <SaveAs :visible.sync="saveas.dialogFormVisible" class="table-h360" :data="saveas.data" @save-success="saveAsSuccess"></SaveAs>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import SaveAs from '@/components/Dictionary/Supplies/SaveAs.vue'
export default {
    name: `Consumable`,
    components: { SaveAs },
    props: {

    },
    data() {
        return {
            title: `耗材领用`,
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            scancode: ``,
            keyword: ``,
            surgeryId: this.$route.query.surgery_id,
            unsaveSupplies: [],
            allSupplies: undefined, // 缓存当前列表，只有重新提交保存之后列表刷新
            url: { baseURL: `/api/AcisSystem/Supplies`,
                get: (query) => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let __index = _.now()
                        if (!that.allSupplies || that.allSupplies.length == 0 || query.reset) {
                            let req = this.myaxios.get(`/api/Nursing/UseSupplies/CollectedSupplies?surgeryInfoId=${this.surgeryId}`)
                            req.then(data => {
                                if (!query.reset) {
                                    data = (data || []).concat(that.unsaveSupplies)
                                } else {
                                    that.unsaveSupplies = []
                                }
                                let r = data.map((d, index) => {
                                    d.id = d.id || undefined
                                    d.dic_supplies = { label: d.name || d.supplies.name, value: d.dic_supplies_id, jianpin: d.supplies && d.supplies.abbr }
                                    d.___index = d.___index || (__index + index)
                                    d.code = d.code || d.supplies && d.supplies.code
                                    d.is_high_value = d.is_high_value || d.supplies && d.supplies.is_high_value
                                    d.spec = d.supplies && d.supplies.spec
                                    let classname = ``
                                    if (d.use_quantity > 0 && d.back_quantity > 0) {
                                        classname = `other otherqty`
                                    }
                                    if (d.use_quantity > 0 && d.back_quantity <= 0) {
                                        classname = `other`
                                    }
                                    if (d.back_quantity > 0 && d.use_quantity <= 0) {
                                        classname = `otherqty`
                                    }

                                    d.class_name = classname
                                    return d
                                })
                                that.allSupplies = r
                                if (this.supplyUseMethod == `1` || (this.supplyUseMethod == `2` && !(this.permissions.findIndex(item => item.permission === `material:draw`) != -1))) {
                                    resolve(r)
                                } else {
                                    resolve(r.concat({ ___index: __index - 999, dic_supplies: undefined, code: undefined, quantity: that.supplyUseMethod != `2` ? 1 : undefined, is_high_value: undefined, is_into_counting: false }))
                                }
                            }).catch(e => reject(e))
                        } else {
                            let r = that.allSupplies.concat({ ___index: __index - 1, dic_supplies: undefined, code: undefined, quantity: that.supplyUseMethod != `2` ? 1 : undefined, is_high_value: undefined, is_into_counting: false })
                            resolve(r)
                        }
                    })
                },
                putMany: (row) => { // 保存更改项目|新增项目
                    let that = this
                    let IsCanDraw = this.permissions && this.permissions.findIndex(item => item.permission === `material:draw`) != -1 // 领用
                    let data = _.differenceWith(that.unsaveSupplies, row, function(arrVal, othVal) {
                        return arrVal.___index == othVal.___index
                    }).concat(row).map(d => {
                        let supplyId = d.dic_supplies_id || (d.dic_supplies && d.dic_supplies.value) || d.dic_supplies
                        let d2 = _.find(that.allSupplies, { id: d.id }) || _.find(that.allSupplies, { ___index: d.___index }) || _.find(that.unsaveSupplies, { ___index: d.___index }) // 因为仅仅追踪更改的数据，部分数据需要从原始数据中取
                        let r = {
                            id: d.id || (d2 && d2.id),
                            dic_supplies_id: supplyId || (d2 && d2.dic_supplies_id),
                            quantity: d.quantity || d2 && d2.quantity,
                            barcode: d.barcode || d2 && d2.barcode,
                            use_quantity: (IsCanDraw && d.quantity && !d.use_quantity && that.supplyUseMethod == `2`) ? d.quantity : (d.use_quantity || d2 && d2.use_quantity),
                            back_quantity: d.back_quantity || d2 && d2.back_quantity,
                            // is_into_counting:d.is_into_counting||d2&&d2.is_into_counting||false,
                            biz_surgery_info_id: this.surgeryId
                        }
                        if (!r.use_quantity || r.use_quantity < 0) r.use_quantity = 0
                        if (!r.back_quantity || r.back_quantity < 0) r.back_quantity = 0
                        return r
                    })
                    // 筛选掉没有dic_supplies_id的项目
                    data = _.filter(data, `dic_supplies_id`)
                    if (data.length == 0) {
                        return
                    }
                    if (this.supplyUseMethod == `1`) {
                        return new Promise((resolve, reject) => {
                            let req = that.myaxios.put(`/api/Nursing/UseSupplies/PutMany`, data)
                            req.then(res => {
                                that.unsaveSupplies = []
                                that.allSupplies = undefined
                                resolve()
                            }).catch(e => reject(e))
                        })
                    } else if (this.supplyUseMethod == `2`) {
                        return new Promise((resolve, reject) => {
                            let postList = _.filter(data, d => !d.id)
                            postList = _.reduce(_.groupBy(postList, `dic_supplies_id`), function(result, value, key) {
                                let r = value[0]
                                r.quantity = _.sumBy(value, `quantity`)
                                r.use_quantity = _.sumBy(value, `use_quantity`)
                                result.push(r)
                                return result
                            }, [])
                            let putList = _.filter(data, d => d.id > 0)

                            let req1 = this.myaxios.post(`/api/Nursing/UseSupplies/PostMany`, postList)
                            let req2 = this.myaxios.put(`/api/Nursing/UseSupplies/PutMany`, putList)
                            this.myaxios
                                .all(req1, req2)
                                .then(() => {
                                    that.unsaveSupplies = []
                                    that.allSupplies = undefined
                                    resolve()
                                })
                                .catch(e => {
                                    reject(e)
                                })
                        })
                    } else {
                        data = _.reduce(_.groupBy(data, `dic_supplies_id`), function(result, value, key) {
                            let r = value[0]
                            r.quantity = _.sumBy(value, `quantity`)
                            result.push(r)
                            return result
                        }, [])
                        return new Promise((resolve, reject) => {
                            let req = that.myaxios.post(`/api/Nursing/UseSupplies/PostMany`, data)
                            req.then(res => {
                                that.unsaveSupplies = []
                                that.allSupplies = undefined
                                resolve()
                            }).catch(e => reject(e))
                        })
                    }
                } },
            collectSupplies: {
                dialogFormVisible: false,
                selected_template: undefined,
                supplies_template: [],
                cache_template: {},
                datalist: [],
                columnList: [{
                    type: `string`,
                    prop: `dic_supplies_id`,
                    label: `编号`,
                    isKey: true
                }, {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `120`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `code`,
                    label: `编码`,
                    width: `180`,
                    isListable: true
                }, {
                    type: `select`,
                    prop: `is_high_value`,
                    label: `耗材类型`,
                    width: `120`,
                    isListable: true,
                    options: `enum_supply_type`
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `数量`,
                    width: `100`,
                    isListable: true
                    // }, {
                    //   type: "bool",
                    //   prop: "is_into_counting",
                    //   label: "纳入清点",
                    //   width: "100",
                    //   isListable: true,
                    //   options:'enum_bool'
                }]
            },
            useType: `-1`,
            supplyUseMethod: this.$root.SupplyUseMethod || 0,
            useTypeArry: []
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    mounted() {
        this.useTypeArry = []
        if (this.permissions) {
            if (this.permissions.findIndex(item => item.permission === `material:draw`) != -1) {
                this.useTypeArry.push({ label: 0, name: `领用` })
            }
            if (this.permissions.findIndex(item => item.permission === `material:use`) != -1) {
                this.useTypeArry.push({ label: 1, name: `使用` })
            }
            if (this.permissions.findIndex(item => item.permission === `material:back`) != -1) {
                this.useTypeArry.push({ label: 2, name: `归还` })
            }
        }
        if (this.useTypeArry.length > 0) {
            this.useType = this.useTypeArry[0].label
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `screenHeight`, `active_ward`, `permissions`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            let me = this
            let IsCanEdit = this.permissions && this.permissions.findIndex(item => item.permission === `material:update`) != -1 // 修改
            let IsCanDraw = this.permissions && this.permissions.findIndex(item => item.permission === `material:draw`) != -1 // 领用
            let IsCanUse = this.permissions && this.permissions.findIndex(item => item.permission === `material:use`) != -1 // 使用
            let IsCanBack = this.permissions && this.permissions.findIndex(item => item.permission === `material:back`) != -1 // 归还

            let cols = [{
                type: `string`,
                prop: `___index`,
                label: `unique`,
                isKey: true
            }, {
                type: `string`,
                prop: `id`,
                label: `编号`
                // isKey: true
            }, {
                type: `remoteselect`,
                prop: `dic_supplies`,
                label: `名称`,
                isListable: true,
                readonly: function(that, { row, area }) {
                    if (area == `list` && this.supplyUseMethod != `0`) {
                        if (row.id && row.id > 0) {
                            return true
                        } else {
                            return false
                        }
                    }
                    return true
                },
                options: `/api/AcisSystem/Supplies/Search`,
                change: (that, { row }) => {
                    let req = this.myaxios.get(`/api/AcisSystem/Supplies/Get/${row.dic_supplies.value}`)
                    req.then(data => {
                        if (row.code) {
                            row.code = data.code
                            row.spec = data.spec
                            row.is_high_value = data.is_high_value
                            // row.is_into_counting = data.is_into_counting
                        } else {
                            row.code = data && data.code
                            row.spec = data && data.spec
                            row.is_high_value = data && data.is_high_value
                            // row.is_into_counting = data.is_into_counting
                            this.allSupplies.push({ ...row })
                            this.$refs[`supplies-list`].ReloadListData()
                        }
                    }).catch(e => {})
                }
            }, {
                type: `string`,
                prop: `spec`,
                label: `规格`,
                width: `180`,
                isListable: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true
            }, {
                type: `select`,
                prop: `is_high_value`,
                label: `类型`,
                width: `120`,
                isListable: true,
                options: `enum_supply_type`
            }, {
                type: `string`,
                prop: `barcode`,
                label: `条形码`,
                width: `180`,
                isListable: this.supplyUseMethod == `1`
            }, {
                type: `number`,
                prop: `quantity`,
                label: this.supplyUseMethod == `0` ? `数量` : (me.supplyUseMethod == `2` ? this.T(`supplyUseMethod.quantity`) : `领用数量`),
                width: `80`,
                isListable: true,
                readonly: function(that, { row, area }) {
                    if (area == `list` && this.supplyUseMethod != `1`) {
                        if (row.id && row.id > 0) {
                            return true
                        } else {
                            return false
                        }
                    }
                    return true
                },
                default: 1,
                change: (that, { row, index }) => {
                    if (me.supplyUseMethod == `2`) {
                        this.$set(row, `use_quantity`, row.quantity)
                    }
                }
            }, {
                type: `float`,
                prop: `use_quantity`,
                label: this.supplyUseMethod == `2` ? this.T(`supplyUseMethod.use_quantity`) : `使用数量`,
                width: `80`,
                isListable: this.supplyUseMethod != `0`,
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        if (row.id && row.id > 0) {
                            return !(IsCanEdit && IsCanUse)
                        }
                    }
                    return true
                },
                blur: (that, { row, index }) => {
                    row.class_name = me.getRowClassName(row)
                }
            }, {
                type: `float`,
                prop: `back_quantity`,
                label: `归还数量`,
                width: `80`,
                isListable: this.supplyUseMethod == `1` || this.T(`supplyUseMethod.back_quantity`),
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        if (row.id && row.id > 0) {
                            return !(IsCanEdit && IsCanBack)
                        }
                    }
                    return true
                },
                blur: (that, { row, index }) => {
                    row.class_name = me.getRowClassName(row)
                }
            }, {
                //   type: "bool",
                //   prop: "is_into_counting",
                //   label: "纳入清点",
                //   width: "120",
                //   isListable: true,
                //   readonly:function(that,{row,area}){
                //     if(area=='list'){
                //       if(row.id&&row.id>0){
                //         return true
                //       }else{
                //         return false
                //       }
                //     }
                //     return true
                //   },
                //   options:'enum_bool',
                //   default:false
                // }, {
                type: `string`,
                prop: `register`,
                label: `领用人`,
                width: `180`,
                isListable: this.supplyUseMethod != `0`
            }, {
                type: `string`,
                prop: `modifier`,
                label: `修改人`,
                width: `180`,
                isListable: this.supplyUseMethod == `0`
            }, {
                type: `datetime`,
                prop: `modify_date`,
                label: `修改时间`,
                width: `180`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `60`,
                isListable: true,
                fixed: `right`,
                readonly: false,
                options: function(that, { row, area }) {
                    if (IsCanDraw && (me.supplyUseMethod == `0` || row.use_quantity == 0 || !row.use_quantity)) {
                        return [{
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `removeItem`,
                            permission: `default`
                        }]
                    } else {
                        return []
                    }
                }
            }]
            return cols
        }
    },

    methods: {
        getRowClassName(row) {
            // let that = this
            let className = ``
            if (row.use_quantity > 0 && row.back_quantity > 0) {
                className = `other otherqty`
            }
            if (row.use_quantity > 0 && row.back_quantity <= 0) {
                className = `other`
            }

            if (row.back_quantity > 0 && row.use_quantity <= 0) {
                className = `otherqty`
            }
            return className
        },
        loadTemplatesView() { // 加载可选模板，弹出模板选择框
            this.collectSupplies.selected_template = undefined
            this.collectSupplies.datalist = []
            let that = this
            this.loadTemplates().then(data => {
                let groupId = _.groupBy(_.filter(data, d => {
                    return `ow_${d.operating_ward_id_data_auth_filter}` == this.active_ward.value ||
            `rw_${d.recovery_ward_id_data_auth_filter}` == this.active_ward.value || d.owner
                }), `id`)
                let ts = _.reduce(groupId, function(result, g, key) {
                    let region = g.map(s => {
                        let ow = s.dic_operating_ward_id && _.find(that.ward_auth, { value: `ow_${s.dic_operating_ward_id}` })
                        let rw = s.dic_recovery_ward_id && _.find(that.ward_auth, { value: `rw_${s.dic_recovery_ward_id}` })
                        return (ow && ow.label) || (rw && rw.label) || that.currentUser.dic_worker_name
                    })
                    let r = {
                        label: g[0].name,
                        value: g[0].id,
                        jianpin: g[0].abbr,
                        code: region.join(`,`),
                        group: _.includes(region, that.currentUser.dic_worker_name) ? `个人模板` : `区域模板`
                    }
                    result.push(r)
                    return result
                }, [])
                this.collectSupplies.supplies_template = _.orderBy(ts, `group`)
                this.collectSupplies.dialogFormVisible = true
            }).catch(e => {
                console.log(e)
            })
        },
        loadTemplates() { // 加载可用模板
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/SuppliesTemplate/Get`)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        addTemplateToList() { // 确认之后，合并已选模板
            let that = this
            let __index = _.now()
            let i = 1
            let unsaveSupplies = that.unsaveSupplies.concat(this.collectSupplies.datalist)
            that.unsaveSupplies = _.reduce(_.groupBy(unsaveSupplies, `dic_supplies_id`), function(result, supplies, key) {
                // 对于未保存的模板需要合并耗材数量
                let item = _.find(supplies, `___index`)// 优先合并到___index不为空的
                let r = { ...(item || supplies[0]) }
                r.quantity = _.sumBy(supplies, s => s.quantity)
                r.___index = r.___index || (__index + i++)
                r.dic_supplies = { label: r.name, value: r.dic_supplies_id }
                r.bingo_new = true
                result.push(r)
                return result
            }, [])
            that.allSupplies = _.differenceWith(that.allSupplies, that.unsaveSupplies, function(arrVal, othVal) {
                return arrVal.dic_supplies_id == othVal.dic_supplies_id && (arrVal.id == 0 || !arrVal.id)
            }).concat(_.orderBy(that.unsaveSupplies, `display_order`))
            this.$refs[`supplies-list`].ReloadListData()
            this.collectSupplies.dialogFormVisible = false
        },
        removeItem({ row, index }) {
            let that = this
            if (row.id && row.id > 0) {
                this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let req = that.myaxios.delete(`/api/Nursing/UseSupplies/Delete/${row.id}`)
                    req.then(data => {
                        that.allSupplies.splice(index, 1)
                        let dindex = _.findIndex(that.unsaveSupplies, { ___index: row.___index })
                        that.unsaveSupplies.splice(dindex, 1)
                        that.$refs[`supplies-list`].ReloadListData()
                    }).catch(e => {
                        that.$message.error(`删除失败`)
                    })
                })
            } else {
                that.allSupplies.splice(index, 1)
                let dindex = _.findIndex(that.unsaveSupplies, { ___index: row.___index })
                that.unsaveSupplies.splice(dindex, 1)
                that.$refs[`supplies-list`].ReloadListData()
            }
        },
        loadSaveAsView() {
            let that = this
            that.saveas.dialogFormVisible = true
            that.saveas.data = {
                supplies: that.allSupplies.map((d, index) => {
                    d.display_order = index + 1
                    return d
                }) || []
            }
        },
        saveAsSuccess() {
            this.$message.success(`另存为模板成功`)
        },
        scanConsumable() {
            if (!this.scancode) {
                this.$message.warning(`请输入或扫码`)
                return
            }
            if (this.supplyUseMethod == `1`) {
                console.log(`条码扫码枪`)
                let req = this.myaxios.post(`/api/Nursing/UseSupplies/Scan`, { barcode: this.scancode, useType: this.useType, biz_surgery_info_id: this.surgeryId })
                req.then(data => {
                    this.unsaveSupplies = []
                    this.allSupplies = undefined
                    this.scancode = ``
                    this.$refs[`supplies-list`].ReloadListData()
                    this.$refs[`scan-code`].scan_val = ``
                    this.$message.success(`扫码成功`)
                }).catch(e => {
                    console.log(e)
                    // this.$message.error(e)
                })
            } else {
                console.log(`测试扫码枪`)
                let req = this.myaxios.get(`/api/AcisSystem/Supplies/Search?keyword=${this.scancode}`)
                req.then(data => {
                    let row = data && data[0]
                    if (row) {
                        let info = row.code && row.code.split(` / `)
                        let spec = ``
                        let code = ``
                        if (info && info.length == 2) {
                            spec = info[0]
                            code = info[1]
                        } else {
                            code = row.code
                        }
                        this.allSupplies.push({ ___index: _.now() + Math.random() * Math.random(), spec: spec, code: code, dic_supplies: row, quantity: 1, is_high_value: undefined, bingo_new: true })
                        this.$refs[`supplies-list`].ReloadListData()
                        this.$refs[`scan-code`].scan_val = ``
                    } else {
                        this.$message.warning(`暂无该耗材记录`)
                    }
                })
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.allSupplies = undefined
            this.$refs[`supplies-list`] && this.$refs[`supplies-list`].ReloadListData()
            if (this.useTypeArry.length > 0) {
                this.useType = this.useTypeArry[0].label
            }
        },
        'collectSupplies.selected_template': function(newval, oldval) { // 加载已选模板详情
            if (!newval) return
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/SuppliesTemplate/TemplateItems/${newval}`)
            req.then(template => {
                let r = _.map(_.filter(template, d => {
                    return !d.supplies.is_deleted
                }), t => {
                    return {
                        dic_supplies_id: t.dic_supplies_id,
                        name: t.supplies && t.supplies.name,
                        code: t.supplies && t.supplies.code,
                        spec: t.supplies && t.supplies.spec,
                        is_high_value: t.supplies && t.supplies.is_high_value,
                        quantity: t.quantity,
                        // is_into_counting:t.supplies.is_into_counting,
                        display_order: t.display_order
                    }
                })
                that.collectSupplies.datalist = _.orderBy(r, `display_order`)
            })
        }
    }
}
</script>
<style scoped lang="less">
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
/deep/ .other {
    .use_quantity {
        color: red !important;
    }
}

/deep/ .otherqty {
    .back_quantity {
        color: red !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Consumable/Index.vue